var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDelete = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.2rem",
    height: "1.2rem",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Trailing icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_226_19841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -2,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: -2,
    y: -2,
    width: "1.2rem",
    height: "1.2rem",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_226_19841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "delete",
    d: "M4.74999 14.583C4.38866 14.583 4.07599 14.4513 3.81199 14.188C3.54866 13.924 3.41699 13.6113 3.41699 13.25V3.5H2.41699V2.417H5.99999V1.521H9.99999V2.417H13.583V3.5H12.583V13.229C12.583 13.6177 12.4547 13.9407 12.198 14.198C11.9407 14.4547 11.6247 14.583 11.25 14.583H4.74999ZM11.5 3.5H4.49999V13.25C4.49999 13.3193 4.52433 13.3783 4.57299 13.427C4.62166 13.4757 4.68066 13.5 4.74999 13.5H11.25C11.3053 13.5 11.361 13.4723 11.417 13.417C11.4723 13.361 11.5 13.3053 11.5 13.25V3.5ZM6.33299 12H7.41699V5H6.33299V12ZM8.58299 12H9.66699V5H8.58299V12ZM4.49999 3.5V13.5V13.25V3.5Z",
    fill: "#161616"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.d76c1fe0.svg";
export { ForwardRef as ReactComponent };